"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdjustablePanel = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var re_resizable_1 = require("re-resizable");
var anchorPosition = {
    left: 'left',
    right: 'right',
};
var mode = {
    light: 'light',
    dark: 'dark',
};
var leftAnchorEnable = {
    top: false,
    right: true,
    bottom: false,
    left: false,
    topRight: false,
    bottomRight: false,
    bottomLeft: false,
    topLeft: false,
};
var rightAnchorEnable = {
    top: false,
    right: false,
    bottom: false,
    left: true,
    topRight: false,
    bottomRight: false,
    bottomLeft: false,
    topLeft: false,
};
var anchorsDisabled = {
    top: false,
    right: false,
    bottom: false,
    left: false,
    topRight: false,
    bottomRight: false,
    bottomLeft: false,
    topLeft: false,
};
var leftAnchorHandleStyles = {
    right: {
        marginRight: '1.4rem',
        display: 'flex',
        alignItems: 'center',
    },
};
var rightAnchorHandleStyles = {
    left: {
        marginLeft: '0.6rem',
        display: 'flex',
        alignItems: 'center',
    },
};
exports.AdjustablePanel = function (_a) {
    var anchor = _a.anchor, _b = _a.collapsed, collapsed = _b === void 0 ? false : _b, _c = _a.colorTheme, colorTheme = _c === void 0 ? 'dark' : _c, isOpen = _a.isOpen, _d = _a.minWidth, minWidth = _d === void 0 ? 400 : _d, _e = _a.maxWidth, maxWidth = _e === void 0 ? 600 : _e, children = _a.children, defaultSize = _a.defaultSize;
    var getHandleComponents = function () {
        if (collapsed) {
            return undefined;
        }
        return {
            left: React.createElement("i", { "data-testid": "drag-handle", className: "icon--drag_vertical" }),
            right: React.createElement("i", { "data-testid": "drag-handle", className: "icon--drag_vertical" }),
        };
    };
    var getHandleEnable = function () {
        if (collapsed) {
            return anchorsDisabled;
        }
        return anchor === anchorPosition.left
            ? leftAnchorEnable
            : rightAnchorEnable;
    };
    var getHandleStyles = function () {
        if (collapsed) {
            return undefined;
        }
        return anchor === anchorPosition.left
            ? leftAnchorHandleStyles
            : rightAnchorHandleStyles;
    };
    return (React.createElement(StyledContainer, { colorTheme: colorTheme, isOpen: isOpen, role: "region", "data-testid": "side-panel-drawer" },
        React.createElement(re_resizable_1.Resizable, { "data-testid": "resizable-region", minWidth: collapsed ? '5.6rem' : minWidth, maxHeight: "100%", maxWidth: collapsed ? '5.6rem' : maxWidth, handleComponent: getHandleComponents(), handleStyles: getHandleStyles(), enable: getHandleEnable(), defaultSize: defaultSize }, children)));
};
var StyledContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: ", ";\n  box-shadow: 0.5rem 0.6rem 2.4rem 0 rgba(0, 0, 0, 0.2);\n  transition: width 0.7s;\n  background-color: ", ";\n\n  .icon--drag_vertical {\n    font-size: 1.8rem;\n    color: ", ";\n  }\n"], ["\n  display: ", ";\n  box-shadow: 0.5rem 0.6rem 2.4rem 0 rgba(0, 0, 0, 0.2);\n  transition: width 0.7s;\n  background-color: ",
    ";\n\n  .icon--drag_vertical {\n    font-size: 1.8rem;\n    color: ",
    ";\n  }\n"])), function (_a) {
    var isOpen = _a.isOpen;
    return (isOpen ? 'flex' : 'none');
}, function (_a) {
    var colorTheme = _a.colorTheme, theme = _a.theme;
    return colorTheme === 'dark' ? theme.colors.NTDarkGrey[900] : theme.colors.white;
}, function (_a) {
    var colorTheme = _a.colorTheme, theme = _a.theme;
    return colorTheme === 'dark' ? theme.colors.white : theme.colors.black;
});
var templateObject_1;
